"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactComponents = require("@ui-propulsion/react-components");
var _util = require("../../util");
var _excluded = ["errors", "index", "register", "minAmount", "maxAmount", "handleAmountChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var CurrencyTextBox = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _errors$payees, _errors$payees2, _errors$payees3;
  var errors = props.errors,
    index = props.index,
    register = props.register,
    minAmount = props.minAmount,
    _maxAmount = props.maxAmount,
    handleAmountChange = props.handleAmountChange,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var registeredPayee = register("payees.".concat(index, ".payeeAmount"), {
    required: 'Required',
    validate: {
      /*
        We cannot use the built in min and max from React Hook Form
        because Propulsion returns a string instead of a number.
      */
      minimum: function minimum(v) {
        return (0, _util.convertToFloat)(v) >= minAmount || "".concat((0, _util.toDollar)(minAmount), " is the minimum amount allowed");
      },
      maxAmount: function maxAmount(v) {
        return (0, _util.convertToFloat)(v) <= _maxAmount || "".concat((0, _util.toDollar)(_maxAmount), " is the maximum amount allowed");
      }
    }
  });
  return /*#__PURE__*/_react.default.createElement(_reactComponents.TextField, Object.assign({
    required: true,
    className: "revisions-revisor__currency-text-box",
    component: "Currency",
    componentRef: ref,
    intent: (errors === null || errors === void 0 || (_errors$payees = errors.payees) === null || _errors$payees === void 0 ? void 0 : _errors$payees[index]) && 'error',
    helperText: ((_errors$payees2 = errors.payees) === null || _errors$payees2 === void 0 || (_errors$payees2 = _errors$payees2[index]) === null || _errors$payees2 === void 0 ? void 0 : _errors$payees2.payeeAmount) && /*#__PURE__*/_react.default.createElement("p", {
      className: "revisions-revisor__payees--error"
    }, (_errors$payees3 = errors.payees) === null || _errors$payees3 === void 0 || (_errors$payees3 = _errors$payees3[index]) === null || _errors$payees3 === void 0 ? void 0 : _errors$payees3.payeeAmount.message)
  }, registeredPayee, {
    onChange: function onChange(e) {
      registeredPayee.onChange(e);
      handleAmountChange(e);
    }
  }, rest));
});
CurrencyTextBox.propTypes = {
  errors: _propTypes.default.shape({
    payees: _propTypes.default.arrayOf(_propTypes.default.shape({
      payeeAmount: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
    }))
  }).isRequired,
  index: _propTypes.default.number.isRequired,
  register: _propTypes.default.func.isRequired,
  minAmount: _propTypes.default.number.isRequired,
  maxAmount: _propTypes.default.number.isRequired,
  handleAmountChange: _propTypes.default.func.isRequired
};
var _default = exports.default = CurrencyTextBox;
